export const HOME = {
  emergentLink: "home-emergent-link",
  ctaStart: "home-cta-start",
  ctaLogin: "home-cta-login",
};

export const AUTH = {
  signupEmail: "signup-email",
  signupPassword: "signup-password",
  signupFirstName: "signup-first-name",
  signupSubmit: "signup-submit",
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  toLogin: "auth-to-login",
  toSignup: "auth-to-signup",
};

export const NAV = {
  dashboard: "nav-dashboard",
  workouts: "nav-workouts",
  meals: "nav-meals",
  coach: "nav-coach",
  progress: "nav-progress",
  pricing: "nav-pricing",
  admin: "nav-admin",
  logout: "nav-logout",
  notifications: "nav-notifications",
  measurements: "nav-measurements",
};

export const ONB = {
  firstName: "onb-first-name",
  age: "onb-age",
  sex: "onb-sex",
  height: "onb-height",
  weight: "onb-weight",
  goalWeight: "onb-goal-weight",
  activity: "onb-activity",
  fitnessGoal: "onb-fitness-goal",
  experience: "onb-experience",
  workoutDays: "onb-workout-days",
  workoutDuration: "onb-workout-duration",
  equipment: "onb-equipment",
  diet: "onb-diet",
  allergies: "onb-allergies",
  likes: "onb-likes",
  dislikes: "onb-dislikes",
  medical: "onb-medical",
  next: "onb-next",
  back: "onb-back",
  submit: "onb-submit",
};

export const DASH = {
  caloriesTile: "dash-calories",
  proteinTile: "dash-protein",
  carbsTile: "dash-carbs",
  fatTile: "dash-fat",
  weightTrend: "dash-weight-trend",
  generateMeals: "dash-generate-meals",
  logWeight: "dash-log-weight",
};

export const WORKOUT = {
  newBtn: "workout-new",
  saveBtn: "workout-save",
  exerciseName: "workout-exercise-name",
  addExercise: "workout-add-exercise",
  addSet: "workout-add-set",
  reps: "workout-set-reps",
  weight: "workout-set-weight",
  rpe: "workout-set-rpe",
  duration: "workout-duration",
  notes: "workout-notes",
  progressionBtn: "workout-progression-generate",
};

export const COACH = {
  input: "coach-input",
  send: "coach-send",
  messages: "coach-messages",
};

export const MEALS = {
  generate: "meals-generate",
  list: "meals-list",
  swap: "meals-swap",
};

export const BILLING = {
  monthly: "billing-monthly",
  annual: "billing-annual",
  subscribe: "billing-subscribe",
  cardContainer: "billing-card-container",
};

export const ADMIN = {
  analyticsCard: "admin-analytics",
  usersTable: "admin-users",
  templateName: "admin-template-name",
  templateKind: "admin-template-kind",
  templateData: "admin-template-data",
  templateSubmit: "admin-template-submit",
  assignTemplate: "admin-assign-template",
  assignUserSelect: "admin-assign-user",
};

export const PHOTOS = {
  upload: "photos-upload-input",
  uploadBtn: "photos-upload-btn",
  list: "photos-list",
};

export const MEASURE = {
  neck: "measure-neck",
  chest: "measure-chest",
  waist: "measure-waist",
  hips: "measure-hips",
  bicep: "measure-bicep",
  thigh: "measure-thigh",
  calf: "measure-calf",
  save: "measure-save",
  list: "measure-list",
};

export const NOTIF = {
  bell: "notif-bell",
  list: "notif-list",
  seed: "notif-seed",
};

export const WEEK = {
  toggleDay: "meals-toggle-day",
  toggleWeek: "meals-toggle-week",
  generateWeek: "meals-generate-week",
};
